export const getGuid = (info: string) => {
    const regex = /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/i;
    const match = info.match(regex);
    return match ? match[0] : null;
}